import React, { useEffect, useState } from 'react';
import {
  Alert,
} from 'shards-react';

const currentEnv = process.env.REACT_APP_ENV;


const EnvBorder: React.FC = (): React.ReactElement => {
  const [alertClose, setAlertClose] = useState(true);


  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);


  // EVENT HANDLER
  // ================================================================================

  const dismiss = () => {
    setAlertClose(false);
  };


  // VIEW
  // ================================================================================

  // 本番環境以外では現在の環境を表示する
  if(currentEnv==='local' || currentEnv==='development' || currentEnv==='staging') {
    return (
      <Alert id="envBorder" className={currentEnv} dismissible={dismiss} open={alertClose}>
        now you&apos;re in {currentEnv} environment. 
      </Alert>
    );
  }

  // 本番環境では表示しない
  return (
    <>
    </>
  );

};

export default EnvBorder;
